import { render, staticRenderFns } from "./CombinationsProductTable.vue?vue&type=template&id=3d26c276&scoped=true"
import script from "./CombinationsProductTable.vue?vue&type=script&lang=ts"
export * from "./CombinationsProductTable.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsProductTable.vue?vue&type=style&index=0&id=3d26c276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d26c276",
  null
  
)

export default component.exports